import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Card } from "../components/ui/card";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";
import { toast } from "sonner";

const CATEGORIES = ["Food", "Skills", "Professional", "Transport", "Housing", "Emotional support", "Other"];

export default function OfferHelp() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "", category: "", location: "", description: "", slots: "",
  });

  const submit = (e) => {
    e.preventDefault();
    if (!form.title || !form.category || !form.description) {
      toast.error("Please fill in all required fields");
      return;
    }
    toast.success("Thank you — your offer is live. AI is matching people now.");
    setTimeout(() => navigate("/dashboard"), 800);
  };

  return (
    <>
      <PageHeader
        eyebrow="Give a hand"
        title="Offer help to your community"
        description="Share your skills, time, or resources. Our AI will pair you with the right neighbors."
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pb-16">
        <Card className="rounded-3xl border-border/60 p-8 sm:p-10 shadow-none">
          <form onSubmit={submit} className="space-y-6">
            <div>
              <Label htmlFor="title" className="font-medium">What are you offering? *</Label>
              <Input
                id="title"
                data-testid="offer-title-input"
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                placeholder="Free legal consultation for immigrants"
                className="mt-2 h-12 rounded-xl"
              />
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <Label className="font-medium">Category *</Label>
                <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
                  <SelectTrigger data-testid="offer-category-select" className="mt-2 h-12 rounded-xl">
                    <SelectValue placeholder="Select" />
                  </SelectTrigger>
                  <SelectContent className="rounded-xl">
                    {CATEGORIES.map(c => (<SelectItem key={c} value={c}>{c}</SelectItem>))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label htmlFor="location" className="font-medium">Location / Remote</Label>
                <Input
                  id="location"
                  data-testid="offer-location-input"
                  value={form.location}
                  onChange={(e) => setForm({ ...form, location: e.target.value })}
                  placeholder="Remote, or Portland, OR"
                  className="mt-2 h-12 rounded-xl"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="slots" className="font-medium">Available slots</Label>
              <Input
                id="slots"
                type="number"
                data-testid="offer-slots-input"
                value={form.slots}
                onChange={(e) => setForm({ ...form, slots: e.target.value })}
                placeholder="e.g. 5"
                className="mt-2 h-12 rounded-xl max-w-xs"
              />
            </div>

            <div>
              <Label htmlFor="desc" className="font-medium">Describe your offer *</Label>
              <Textarea
                id="desc"
                data-testid="offer-desc-input"
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                placeholder="Tell people how, when and who you can help..."
                className="mt-2 rounded-xl min-h-32"
              />
            </div>

            <div className="flex gap-3 pt-2">
              <Button
                type="submit"
                data-testid="offer-submit-btn"
                className="rounded-full bg-secondary hover:bg-secondary/90 h-12 px-8 shadow-sm hover:-translate-y-0.5 transition-all text-white"
              >
                Publish offer
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={() => navigate(-1)}
                data-testid="offer-cancel-btn"
                className="rounded-full h-12 px-6"
              >
                Cancel
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </>
  );
}
